<app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
<form *ngIf="clientForm" [formGroup]="clientForm" novalidate #formDirective="ngForm" (ngSubmit)="addClient(clientForm.value)">
    <div class='form-row my-row'>
        <div class='col-6 col-lg-auto pb-3 my-col'>  
            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'SUPER-ADMIN.CLIENT.FORM.NAME' | translate }}" formControlName="name" id="name">
                <mat-error *ngIf="hasError('name','required')">{{ "SUPER-ADMIN.CLIENT.FORM.ERRORS.NAME-REQUIRED" | translate }}</mat-error>
            </mat-form-field>

            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'SUPER-ADMIN.CLIENT.FORM.REFERENCE' | translate }}"
                formControlName="referenceNumber" id="referenceNumber">
            </mat-form-field>

            <mat-form-field class="mx-2">
                <input matInput type="text" placeholder="{{ 'SUPER-ADMIN.CLIENT.FORM.URL' | translate }}" formControlName="url" id="url">
            </mat-form-field>
        </div>
    </div>

    <div class="form-row my-row">
        <div class='col-6 col-lg-auto pb-3 my-col'>
            <div class="form-check form-switch mx-2">
                <input class="form-check-input" type="checkbox" id="directory" formControlName="directory">
                <label class="form-check-label" for="directory">{{ "SUPER-ADMIN.CLIENT.FORM.DIRECTORY" | translate }}</label>
            </div>
        </div>
    </div>

    <div class="form-row my-row">
        <div class='col-6 col-lg-auto pb-3 my-col'>
            <div class="form-check form-switch mx-2">
                <input class="form-check-input" type="checkbox" id="cgu_mml" formControlName="cgu_mml">
                <label class="form-check-label" for="cgu_mml">{{ "SUPER-ADMIN.CLIENT.FORM.CGU-MML" | translate }}</label>
            </div>
        </div>
    </div>

    <div class='form-row my-row'>
        <div class='col my-col'>
            <button type="submit" class="btn btn-primary mx-1" [disabled]="!clientForm.valid">{{ "BUTTONS.ADD" | translate }}</button>
        </div>
    </div>
</form>
